export const biodata = {
  firstname: "",
  middlename: "",
  lastname: "",
  date_of_birth: "", // new entry for PD: added
  ageinyears: "",
  gender: "",
  occupation: "",
  maritalstatus: "",
  address: "",
  years_of_formal_education: "", // new entry for PD: added
  lga_of_origin: "", // new entry for PD: added
  city: "",
  state: "",
  country_of_origin: "", // new entry for PD: added
  religion: "",
  tribe: "",
  informant: "",
  hospital: "",
  id: "",
  phone_number: "",
  phone_number_1: "",
  email_address: "",
  next_of_kin: "",
  next_of_kin_relationship: "",
  nok_phone_number: "", // new entry for PD: added
  handedness: "", // new entry for PD: added
}

// function populateBiodata(source){
//   return Object.assign(biodata, source);
// }

// function updateField(field, value){
//   this[field] = value;
// }